import { HttpErrorResponse } from "@angular/common/http";

import { GroupModel } from "@core/models/groups.model";
import { RightModel } from "@core/models/rights.model";
import { createAction, props } from "@ngrx/store";

export const GROUPS_ACTION_FAILURE = createAction(
  "[Groups] Groups Action Failure",
  props<{ error: HttpErrorResponse }>()
);

export const RIGHTS_ACTION_FAILURE = createAction(
  "[Groups] Rights Action Failure",
  props<{ error: HttpErrorResponse }>()
);

export const SET_GROUPS_LOADING = createAction(
  "[Groups] Set Groups Loading",
  props<{ loading: boolean }>()
);

export const SET_RIGHTS_LOADING = createAction(
  "[Groups] Set Rights Loading",
  props<{ loading: boolean }>()
);

export const SET_GROUPS_LIST = createAction(
  "[Groups] Set Groups List",
  props<{ groupsList: Array<GroupModel> }>()
);

export const SET_RIGHTS_LIST = createAction(
  "[Groups] Set Rights List",
  props<{ rightsList: Array<RightModel> }>()
);

export const LOAD_GROUPS = createAction("[Groups] Load Groups");
export const LOAD_RIGHTS = createAction("[Groups] Load Rights");

export const SAVE_GROUP = createAction(
  "[Groups] Save Group",
  props<{
    data: Pick<GroupModel, "description" | "name"> & { rights: string[] };
  }>()
);
export const UPDATE_GROUP = createAction(
  "[Groups] Update Group",
  props<{
    data: Pick<GroupModel, "description" | "name" | "id" | "version"> & {
      rights: string[];
    };
  }>()
);
